import CompanyApiClient from '@/api/CompanyApiClient';
import BaseService from '@/services/BaseService';

class CompanyClientService extends BaseService {

	async getAgencyListAsync (...args: Parameters<typeof CompanyApiClient.getAgencyList>) {
		const { data } = await CompanyApiClient.getAgencyList(...args);
		return data;
	}

	async getAgencyForOrganizationalChartAsync (...args: Parameters<typeof CompanyApiClient.getAgencyForOrganizationalChart>) {
		const { data } = await CompanyApiClient.getAgencyForOrganizationalChart(...args);
		return data;
	}

	async getCompaniesByUserIdAsync (...args: Parameters<typeof CompanyApiClient.getCompaniesByUserId>) {
		const { data } = await CompanyApiClient.getCompaniesByUserId(...args);
		return data;
	}

	async getCompaniesForOrganizationAsync (...args: Parameters<typeof CompanyApiClient.getCompaniesForOrganization>) {
		const { data } = await CompanyApiClient.getCompaniesForOrganization(...args);
		return data;
	}

}

const companyClientServiceSingleton = new CompanyClientService();

export function useCompanyClientService () {
	return companyClientServiceSingleton;
}
